import http from '@/api/http.js'

export default {
    // Лента диалогов (возвращаем массив, даже если сервер отдаёт {count, results})
    async getConversations({ page = 1, limit = 50 } = {}) {
        const res = await http.get('/messages/', { params: { page, limit } })
        const data = res?.data
        return Array.isArray(data) ? data : (Array.isArray(data?.results) ? data.results : [])
    },

    // Ensure 1:1 (личная новая тема при force_new=true)
    ensure1to1(userId, { forceNew = false } = {}) {
        return http
            .post('/messages/ensure-1to1', { user_id: Number(userId), force_new: !!forceNew })
            .then(r => r.data)
    },

    // Ensure контекстного треда по сущности
    ensureThread({ user_id, entity_type, entity_id, entity_title, entity_url }) {
        return http
            .post('/messages/ensure-thread', {
                user_id: Number(user_id),
                entity_type, // 'contract' | 'work' | 'facility' | 'org'
                entity_id: String(entity_id),
                entity_title,
                entity_url,
            })
            .then(r => r.data)
    },

    // История сообщений треда
    getMessages(conversationId, { before_id, limit = 50 } = {}) {
        return http
            .get(`/messages/${conversationId}/messages`, { params: { before_id, limit } })
            .then(r => r.data)
    },

    // Отправка сообщения
    sendMessage(conversationId, body) {
        return http.post(`/messages/${conversationId}/messages`, body).then(r => r.data)
    },

    // Пометка прочтения
    markRead(conversationId, last_message_id) {
        return http.post(`/messages/${conversationId}/read`, { last_message_id }).then(r => r.data)
    },
}